import { PostProperties } from "../types";
import image from "../img/lostGemMarthen.jpg";

const post: PostProperties = {
  id: 24,
  title: "Marthen - Fabrica 126, Sofia (13.04.2019)",
  content:
    "We present to you the very first Lost Gem from a Bulgarian DJ, none other than Marthen, the co-founder of this project. This is a recording from his very first official gig and is quite different from what he plays nowadays. So, without further ado, enjoy listening to a trip down memory lane.",
  image,
  buttonText: "Listen Here",
  buttonUrl: "https://soundcloud.com/shubinproject/marthen-fabrica126-13042019",
  category: "Lost Gem",
  translationsBg: {
    content:
      "Представяме ви първия Lost Gem от български DJ – не кой да е, а Marthen, съоснователят на този проект. Това е запис от първото му официално участие и е доста по-различно от това, което пуска в наши дни. Така че, без повече приказки, насладете се на пътешествие в миналото.",
  },
};

export default post;
